import { lazyLoad } from 'utils/loadable';

const PolicyTemplatePage = lazyLoad(() =>
  import(
    /*  webpackChunkName: 'PolicyTemplatePage', webpackPrefetch: true */ '.'
  ),
);

// routes declaration
export const policyRoutes = [
  {
    component: PolicyTemplatePage,
    path: 'terms-of-use',
    topic: 'termsandconditions',
    sub_topic: 'termsofuse',
    allowedAfterLogin: true,
  },
  {
    component: PolicyTemplatePage,
    path: 'privacy-policy',
    topic: 'termsandconditions',
    sub_topic: 'privacypolicy',
    allowedAfterLogin: true,
  },
  {
    component: PolicyTemplatePage,
    path: 'cookies-policy',
    topic: 'termsandconditions',
    sub_topic: 'securitypolicy',
    allowedAfterLogin: true,
  },
  {
    component: PolicyTemplatePage,
    path: 'payment-policy',
    topic: 'termsandconditions',
    sub_topic: 'paymentpolicy',
    allowedAfterLogin: true,
  },
];
